module.exports = __webpack_public_path__ + "static/media/arrow-white.11175365.svg";